import React from 'react';
import { zoomTableActionsConfig } from '../../commons/zoomTable/zoomTableConfig';
import { RenderRetailTableActionButtons } from '../../commons/tableActionButton/tableActionButton';
import { locationTypeOptions } from '../../helper/vasChargesHelper';
import { getFormattedDate } from '../../../services/helpers';
import styles from './vasCharges.scss';
import download from '../../../assets/images/download-theme.svg';

const getAddressList = (addressList, chargeLocationIds, chargeLocationType) => {
  let addresses = [];
  const locationType = (locationTypeOptions || []).find(
    item => item.key === 'RIVIGO'
  );
  (addressList || []).forEach(addressItem => {
    if (
      addressItem.addressId &&
      chargeLocationIds.indexOf(addressItem.addressId) >= 0
    ) {
      if (locationType.key === chargeLocationType) {
        addresses.push(addressItem.ouCode);
      } else {
        addresses.push(addressItem.address);
      }
    }
  });
  return addresses;
};

export const vasChargesConfig = {
  columns: [
    {
      Header: 'Receipt Date',
      headerClassName: 'zt-custom-th flex-13',
      sortable: false,
      className: 'zt-custom-td flex-13',
      accessor: 'receiptDate',
      Cell: row => (
        <div className="l-row a-center">
          {row.original.receiptDate
            ? getFormattedDate(row.original.receiptDate)
            : '-'}
        </div>
      )
    },
    {
      Header: 'Charge Location',
      headerClassName: 'zt-custom-th flex-13',
      className: 'zt-custom-td flex-13',
      sortable: false,
      accessor: 'chargeLocationType',
      Cell: row => row.original.chargeLocationType || '-'
    },
    {
      Header: 'Address',
      headerClassName: 'flex-20 zt-custom-th',
      className: 'zt-custom-td flex-20',
      sortable: false,
      accessor: 'address',
      Cell: row => {
        const addresses = getAddressList(
          row.original.addressDTOList,
          row.original.chargeLocationIds,
          row.original.chargeLocationType
        );
        return (
          <ul style={{ paddingLeft: '1rem' }}>
            {addresses.map(item => (
              <li className="break-word">{item}</li>
            ))}
          </ul>
        );
      }
    },
    {
      Header: 'Activity',
      headerClassName: 'flex-13 zt-custom-th',
      className: 'zt-custom-td flex-13',
      sortable: false,
      accessor: 'activityType',
      Cell: row => row.original.activityType || '-'
    },
    {
      Header: 'Count of Cnotes',
      headerClassName: 'flex-10 zt-custom-th',
      className: 'zt-custom-td flex-10',
      sortable: false,
      accessor: 'cnoteCount',
      Cell: row => row.original.cnoteCount || '-'
    },
    {
      Header: 'Download',
      headerClassName: 'flex-12 zt-custom-th',
      className: 'zt-custom-td flex-12',
      sortable: false,
      Cell: row => (
        <div>
          <a
            className={styles.download}
            href={row.original.receiptUrl}
            target="_blank"
          >
            <img src={download} />
            <span>Receipt</span>
          </a>
          <br />
          <br />
          <a
            className={styles.download}
            href={row.original.emailEvidenceUrl}
            target="_blank"
          >
            <img src={download} />
            <span>Email Evidence</span>
          </a>
        </div>
      )
    },
    {
      Header: 'Action',
      headerClassName: 'flex-12 zt-custom-th',
      className: 'flex-12',
      sortable: false,
      Cell: obj => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.VAS_CHARGES.buttons}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No VAS found',
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 21rem)' }
};

export const vasChargesActionConfig = {
  buttons: [
    {
      label: 'Edit',
      labelOnly: true,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.VAS_CHARGES.actions &&
          zoomTableActionsConfig.VAS_CHARGES.actions.openEditModal
        ) {
          zoomTableActionsConfig.VAS_CHARGES.actions.openEditModal(rowData);
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    }
  ]
};
